import React, { useMemo } from 'react';
import PcConsoleBarChart from '../ChartComponent/PcConsoleBarChart';
import MobileBarChart from '../ChartComponent/MobileBarChart';
import { Col, Row } from 'tea-component';
import { useIntl } from 'umi';

export default function GameStoreBarChart({
  gameStore,
  xAxisList,
  selectedStacked,
  commonParams,
  platform,
  lifetimeStacked,
  loading,
}: any) {
  const renderList = useMemo(() => {
    return [
      {
        title: 'Selected User Score',
        data: selectedStacked || [],
        leftTitle: 'Selected Reviews-1',
        rightTitle: 'Selected User Score',
      },
      {
        title: 'Lifetime User Score',
        data: lifetimeStacked || [],
        leftTitle: 'Lifetime Reviews-1',
        rightTitle: 'Lifetime User Score',
      },
    ];
  }, [selectedStacked, lifetimeStacked]);
  const { formatMessage } = useIntl();
  return (
    <Row>
      {renderList.map(({ data, title, leftTitle, rightTitle }) => (
        <Col span={12} key={title}>
          {gameStore === 'metacritic' ? (
            <PcConsoleBarChart
              height={270}
              platform={platform}
              leftTitle={formatMessage({ id: leftTitle })}
              rightTitle={formatMessage({ id: rightTitle })}
              dataList={data}
              commonParams={commonParams}
              loading={loading}
            ></PcConsoleBarChart>
          ) : (
            <MobileBarChart
              height={270}
              dataList={data}
              xAxisList={xAxisList}
              commonParams={commonParams}
              tooltipTitle={formatMessage({ id: title })}
              loading={loading}
            ></MobileBarChart>
          )}
        </Col>
      ))}
    </Row>
  );
}
